import {
  CHANGE_URL_FILE,
  CHANGE_TITLE_NAME,
  CHANGE_FILE_NAME,
  CHANGE_TYPE_FILE,
  CHANGE_INDICATION_NAME
} from '../actions/emailAction';
const initialState = {
  file: null,
  loading: false,
  error: null,
  title: "",
  filename: "",
  typefile: "",
  indication: ""
}

// Use the initialState as a default value
export default function emailReducer(state = initialState, action) { 
  switch (action.type) {
    case CHANGE_URL_FILE: {
      return {
        ...state,
        loading: true,
        error: null,
        file: action.payload.url
      }
    }
    case CHANGE_TITLE_NAME: {
      return {
        ...state,
        title: action.payload.titleName
      }
    }
    case CHANGE_FILE_NAME: {
      return {
        ...state,
        filename: action.payload.fileName
      }
    }
    case CHANGE_TYPE_FILE: {
      return {
        ...state,
        typefile: action.payload.typeFile
      }
    }
    case CHANGE_INDICATION_NAME: {
      return {
        ...state,
        indication: action.payload.indicat
      }
    }
    default:
      return state
  }
}